/**
 * Unofficial Google Translate (client=gtx) — same helper already used for
 * cancellation remarks in PassangerData / hotelDisplay.
 * Not a paid Cloud Translation product.
 */

const memoryCache = new Map();

export function hasHebrewScript(text) {
  return /[\u0590-\u05FF]/.test(String(text || ""));
}

function localStorageKey(raw) {
  return `translate_he_${String(raw || "").slice(0, 80)}`;
}

function readLocalCache(raw) {
  if (typeof localStorage === "undefined") return "";
  try {
    return String(localStorage.getItem(localStorageKey(raw)) || "").trim();
  } catch {
    return "";
  }
}

function writeLocalCache(raw, translated) {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(localStorageKey(raw), translated);
  } catch {
    /* quota / private mode */
  }
}

export function parseGoogleGtxTranslation(data) {
  if (!data || !Array.isArray(data[0])) return "";
  return data[0]
    .map((item) => (Array.isArray(item) ? item[0] : ""))
    .join("");
}

export async function translateTextToHebrew(text) {
  const raw = String(text || "").trim();
  if (!raw) return "";
  if (hasHebrewScript(raw)) return raw;

  const key = raw.toLowerCase();
  if (memoryCache.has(key)) return memoryCache.get(key);

  const cached = readLocalCache(raw);
  if (cached) {
    memoryCache.set(key, cached);
    return cached;
  }

  try {
    const response = await fetch(
      `https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=he&dt=t&q=${encodeURIComponent(raw)}`
    );
    if (!response.ok) return raw;
    const data = await response.json();
    const translated = String(parseGoogleGtxTranslation(data) || "").trim() || raw;
    memoryCache.set(key, translated);
    writeLocalCache(raw, translated);
    return translated;
  } catch {
    return raw;
  }
}

export function clearTranslateTextToHebrewCache() {
  memoryCache.clear();
}
